export default function MyStory() {
  return (
    <section id="story" className="py-20 px-6 bg-[#F8F6F0]">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="w-full h-[600px] rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/b76e33d7df7d3569da09f8f7dff7ddd0.jpg"
              alt="Maram Story"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-bold text-[#C9A88A] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              قصتي
            </h2>
            <div className="w-24 h-1 bg-[#D4AF7A] mb-8"></div>
            
            <div className="space-y-6 text-[#3D3D3D] leading-relaxed text-lg">
              <p className="font-medium">
                Luxury Products by Maram هو امتداد لذوقي وشغفي بالتفاصيل.
              </p>
              <p>
                أؤمن أن الفخامة الحقيقية تكمن في الاختيار،
                وفي الإحساس اللي تعطيه القطعة لصاحبتها.
              </p>
              <p>
                كل ما أقدّمه هنا اخترته وكأني أشتريه لنفسي،
                بنفس الحرص، وبنفس الحب.
              </p>
              <p className="italic text-[#C9A88A] font-medium">
                "الفخامة ليست في السعر، بل في الشعور الذي تمنحه لك القطعة"
              </p>
            </div>

            <div className="pt-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-16 flex items-center justify-center bg-[#D4AF7A] rounded-full">
                  <i className="ri-heart-3-fill text-3xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-[#3D3D3D]">شغف حقيقي</h4>
                  <p className="text-[#3D3D3D]/70">كل قطعة تحمل قصة وذوق خاص</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center bg-[#D4AF7A] rounded-full">
                  <i className="ri-star-fill text-3xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold text-[#3D3D3D]">جودة مضمونة</h4>
                  <p className="text-[#3D3D3D]/70">اختيار دقيق من مصادر موثوقة</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
